export const SET_HOLDINGS = 'SET_HOLDINGS';
